import packageJson from '../../package.json';
export default class BuildInfo {
    static appName: string = packageJson.name;
    static versionName: string = packageJson.version + " PWA";
    static build: number = packageJson.build;
}